export const SET_SEO_DATA = 'SET_SEO_DATA'
export const SET_CNV_ID = 'SET_CNV_ID'
export const UPDATE_PHONE_CODE_STATUS = 'UPDATE_PHONE_CODE_STATUS'
export const DELETE_SEO_DATA = 'DELETE_CNV_ID'
